import React from 'react';
import Submission from 'types/Submission';
import { useState } from 'react';
import SubmissionDeleteModal from 'components/SubmissionDeleteModal';
import SubmissionRating from 'components/SubmissionRating';
import UgcRequest from 'types/UgcRequest';
import { LumenButton } from '@photoshelter/socialie-components';
import { useTranslation } from 'react-i18next';

interface Props {
  submission: Submission;
  ugcRequest: UgcRequest;
}

export default function SubmissionThumbnailActions(props: Props) {
  const { submission, ugcRequest } = props;
  const { t } = useTranslation();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  return (
    <>
      <div className="dark absolute top-1 right-1 z-10 flex items-center gap-0.5">
        <LumenButton
          color="secondary"
          size="sm"
          leftIcon="trash-outline"
          aria-label={t('submissionDeleteModal.trigger')}
          className="opacity-0 transition duration-250 group-hover:opacity-100"
          onClick={() => setIsDeleteModalOpen(true)}
        />

        <SubmissionRating submission={submission} theme="thumbnail" />
      </div>

      <SubmissionDeleteModal
        ugcRequest={ugcRequest}
        submissions={[submission]}
        onRequestClose={() => setIsDeleteModalOpen(false)}
        isOpen={isDeleteModalOpen}
      />
    </>
  );
}
